<header>
  <app-header></app-header>
</header>
<router-outlet></router-outlet>
<footer>
  <app-footer></app-footer>
</footer>